import asyncRoute from 'lib/asyncRoute';

export const Box = asyncRoute(() => import('./Box'));
export const Loading = asyncRoute(() => import('./Loading'));
export const NotFound = asyncRoute(() => import('./NotFound'));
export const NotOpen = asyncRoute(() => import('./NotOpen'));
export const DBox = asyncRoute(() => import('./DBox'));





// WEBPACK FOOTER //
// ./src/pages/index.async.js